@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.bulk-apply-message {
  padding: 0 15px;
  font-size: 13px;
  color: @bulk-apply--message--text-color;
  background: @bulk-apply--message--background-color;
  line-height: 40px;
}
